var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",class:{
        'layout--navigation-expanded': _vm.navigationExpanded,
        'layout--search-expanded': _vm.searchExpanded
    }},[_c('site-header',{on:{"navigation-expanded":_vm.expandNavigation,"navigation-collapsed":_vm.collapseNavigation,"search-expanded":_vm.expandSearch,"search-collapsed":_vm.collapseSearch}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('div',{staticClass:"layout__footer"},[_c('site-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }